import { PageOf } from "./models/PageOf";
import { JSONList } from "./models/JSONList";

export function concatenateApiPaginatedResponse<T>(data: PageOf<T>[]): T[] {
	return data && data?.length > 0 && data[0]
		? data.reduce((acc, { content }) => acc.concat(...content), [])
		: [];
}

export function concatenateApiSJSONListResponse<T>(data: JSONList<T>[]): T[] {
	return data ? data.reduce((acc, { list }) => acc.concat(...list), []) : [];
}
